<template>
  <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>Twitter</title>
    <path
      d="M12.286 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm-2.114 18.382c5.31 0 8.214-4.4 8.214-8.213 0-.126 0-.252-.006-.371a5.903 5.903 0 001.443-1.497 5.884 5.884 0 01-1.659.455c.6-.36 1.054-.922 1.27-1.598a5.866 5.866 0 01-1.832.7 2.887 2.887 0 00-4.915 2.634 8.192 8.192 0 01-5.95-3.017c-.246.425-.39.922-.39 1.449 0 1 .509 1.885 1.287 2.4a2.83 2.83 0 01-1.305-.359v.036c0 1.4.994 2.562 2.317 2.832-.24.065-.497.101-.76.101-.186 0-.366-.018-.545-.054a2.881 2.881 0 002.694 2.006 5.805 5.805 0 01-4.275 1.191 8.044 8.044 0 004.412 1.305z"
      fill-rule="evenodd"
    />
  </svg>
</template>
